document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('section.slider .keen-slider');

	sliders.forEach(slider => {
		let keenslider = new KeenSlider(slider, {
			loop: false,
			slides: {
				perView: 1,
				spacing: 16,
			},
			breakpoints: {
				'(min-width: 512px)': {
					slides: {
						perView: 1.25,
						spacing: 24,
					},
				},
				'(min-width: 768px)': {
					slides: {
						perView: 1.5,
						spacing: 24,
					},
				},
				'(min-width: 992px)': {
					slides: {
						perView: 2,
						spacing: 40,
					},
				},
				'(min-width: 1536px)': {
					slides: {
						perView: 2.4,
						spacing: 40,
					},
				},
			},
		},
		)
	})
})
